import { getFilesDeep } from "../ManageFiles/fileUtils";

function formatDate(yyyymmdd) {
    if (!yyyymmdd || yyyymmdd.length !== 8) return yyyymmdd;
    const year = yyyymmdd.substring(0, 4);
    const month = yyyymmdd.substring(4, 6);
    const day = yyyymmdd.substring(6, 8);
    return `${year}-${month}-${day}`;
}

export function sortFilesByDate(files, order = 'asc') {
    // clona l'array per non mutare l'originale
    return [...files].sort((a, b) => {
        const da = new Date(a.date);
        const db = new Date(b.date);
        if (order === 'asc') {
            return da - db;
        } else {
            return db - da;
        }
    });
}

export async function fetchFiles(IDD, FolderName) {
    try {
        const data = await getFilesDeep(IDD, FolderName);
        console.log(data);
        if (data && data.output && Array.isArray(data.output)) {
            return data.output
                .filter((item) => item.filename && item.timestamp_date)
                .map((item) => ({
                    filename: item.filename,
                    date: formatDate(item.timestamp_date),
                }));
        }
        return [];
    } catch (error) {
        console.error("Errore nel recupero dei file:", error);
        throw error;
    }
}

